"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProductsApp_1 = require("./createProductsApp");
const ProductList_originallongdrink_1 = require("./ProductList-originallongdrink");
const BrandList_1 = require("./BrandList");
const CategoryList_1 = require("./CategoryList");
exports.default = (0, createProductsApp_1.default)({
    ProductListComponent: ProductList_originallongdrink_1.default,
    BrandListComponent: BrandList_1.default,
    CategoryListComponent: CategoryList_1.default,
});
